import { MouseEvent } from 'react'

export const onStopPropagationHandler = (e: MouseEvent) => {
  e.stopPropagation()
}
